// Controller contract — see AGENTS.md. Do not change without integrator sign-off.

/** Standard NES controller button order for the serial shift register. */
export enum Button {
    A = 0,
    B = 1,
    Select = 2,
    Start = 3,
    Up = 4,
    Down = 5,
    Left = 6,
    Right = 7,
}

export interface Controller {
    /** Write to $4016 bit 0. 1->0 transition latches current button state. */
    writeStrobe(value: number): void;
    /** Read $4016/$4017: next serial bit (0 or 1). Returns 1 after the 8 buttons. */
    read(): number;
}

/** No controller connected: reads 0, like a real NES front-loader port.
 *  (Returning 1 makes pad-2 look fully pressed and breaks games like SMB
 *  that compare (pad1|pad2) against exact button values.) */
export class NullController implements Controller {
    writeStrobe(_value: number): void { /* ignore */ }
    read(): number { return 0; }
}
